




























import mixins from 'vue-typed-mixins';
import { ResourceItem } from '@/utils/ResourceUtils';
export default mixins().extend({
  props: {
    value: {
      type: Object as () => ResourceItem,
      required: true,
    },
  },

  data(): {
    visible: boolean;
  } {
    return {
      visible: false,
    };
  },

  mounted() {
    //
  },
});
